import { Col, Row, Select } from "antd";
import "./MultiSelectFilter.css";

const { Option } = Select;

interface MultiSelectFilterProps {
  value: (number | string)[];
  onChange: any;
  options: { id: number | string; name: string }[];
  label: string;
  placeholder?: string;
  optionLabelKey?: string;
  optionValueKey?: string;
  marginBottomValue?: number;
  dropDownWidth?: number;
}

const MultiSelectFilter = ({
  value,
  onChange,
  options,
  label,
  marginBottomValue = 20,
  dropDownWidth,
  placeholder = "Select options",
  optionLabelKey = "name",
  optionValueKey = "id",
}: MultiSelectFilterProps) => {
  const getOptionLabel = (item: any) => {
    return item[optionLabelKey] || item.name || item.full_name || "Unknown";
  };

  const getOptionValue = (item: any) => {
    return item[optionValueKey] || item.id;
  };

  return (
    <Row style={{ marginBottom: marginBottomValue, alignItems: "center", width: dropDownWidth }}>
      <Col span={6}>
        <strong>{label}:</strong>
      </Col>
      <Col span={18}>
        <Select
          mode="multiple"
          value={value}
          onChange={onChange}
          style={{ width: "100%" }}
          allowClear
          placeholder={placeholder}
          showSearch
          optionFilterProp="children"
        >
          {options?.map((item) => {
            const optionValue = getOptionValue(item);
            const optionLabel = getOptionLabel(item);
            return (
              <Option key={optionValue} value={optionValue}>
                {optionLabel}
              </Option>
            );
          })}
        </Select>
      </Col>
    </Row>
  );
};

export default MultiSelectFilter;